'use client';

import { useRouter } from 'next/navigation';

import { zendesk } from '@flipster/features/src/shared/zendesk/url';
import { Button } from '@flipster/react/design-system';
import { css } from '@flipster/styled-system/css';
import { hstack, vstack } from '@flipster/styled-system/patterns';

import { Footer } from '@web/app/_layout/footer';

import NotFoundIcon from './404.svg';

const NotFound = () => {
  const router = useRouter();

  return (
    <>
      <main className={vstack({ h: 'minHeightWithoutNavigation', justify: 'center' })}>
        <NotFoundIcon className={css({ w: { base: 184, tablet: 254 }, mb: { base: 32, tablet: 80 } })} />
        <h1 className={css({ textStyle: 'Display/L', color: 'content.default.level-4', mb: 16 })}>Whoops!</h1>
        <div
          className={css({
            textStyle: 'Text/L/Regular',
            color: 'content.default.level-2',
            textAlign: 'center',
          })}
        >
          <p>Sorry, we could not find what you are looking for.</p>
          <p>Please check your URL.</p>
        </div>
        <Button
          hierarchy='primary'
          color='accent'
          size='large'
          as='a'
          href={zendesk.getUrl('RequestNew')}
          newTab
          label='Contact us for support'
          css={{ display: { tablet: 'none' }, mt: 30 }}
        />
        <div className={hstack({ display: { base: 'none', tablet: 'flex' }, mt: 60, gap: 8 })}>
          <Button
            hierarchy='secondary'
            color='neutral'
            size='large'
            onClick={() => router.back()}
            label='Go back'
            css={{ w: 200 }}
          />
          <Button
            hierarchy='secondary'
            color='neutral'
            size='large'
            onClick={() => router.refresh()}
            label='Refresh'
            css={{ w: 200 }}
          />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
